import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.short.clinVarSignificance',
  title: {
    id: 'omicsExplorer.filters.short.clinVarSignificance',
    defaultMessage: 'ClinVar Significance',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'clinvarSignificance',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.pathogenic',
        searchValue: 'Pathogenic:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.pathogenic',
          defaultMessage: 'Pathogenic',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.likelyPathogenic',
        searchValue: 'Likely pathogenic:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.likelyPathogenic',
          defaultMessage: 'Likely Pathogenic',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.uncertainSignificance',
        searchValue: 'Uncertain significance:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.uncertainSignificance',
          defaultMessage: 'Uncertain Significance',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.benign',
        searchValue: 'Benign:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.benign',
          defaultMessage: 'Benign',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.likelyBenign',
        searchValue: 'Likely benign:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.likelyBenign',
          defaultMessage: 'Likely Benign',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.conflictingInterpretations',
        searchValue:
          'Conflicting interpretations of pathogenicity:like,Conflicting classifications of pathogenicity:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.conflictingInterpretations',
          defaultMessage: 'Conflicting Interpretations',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.association',
        searchValue: 'association:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.association',
          defaultMessage: 'Association',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.riskFactor',
        searchValue: 'risk factor:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.riskFactor',
          defaultMessage: 'Risk Factor',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.drugResponse',
        searchValue: 'drug response:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.drugResponse',
          defaultMessage: 'Drug Response',
        },
      },
      {
        id: 'omicsExplorer.filters.short.clinVarSignificance.notProvided',
        searchValue: 'not provided:like',
        intlLabel: {
          id: 'omicsExplorer.filters.short.clinVarSignificance.notProvided',
          defaultMessage: 'Not Provided',
        },
      },
    ],
  },
};
